<template>
  <div class="ym-star-component">
    <div class="star-list">
      <div class="star-item"
           v-for="(item, index) in starList"
           :key="index"
           @click="toggleIconStatus(item.status)"
      >
        <ym-icon class="icon-rate"
                  :class="{'is-active': item.status}"
                  :name="handleIcon(item.status)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'YmStar',
    data() {
      return {
        starList: [],
        num: 5,
      };
    },
    props: {
      starNum: {
        type: Number,
        default: 5,
      },
    },
    methods: {
      fetchStarList(starNum) {
        this.starList = [];
        for (let i = 0; i < starNum; i++) {
          this.starList.push({ status: true });
        }
        this.num = this.starNum;
      },
      handleIcon(status) {
        if (!status) return 'rate';
        return 'rate-fill';
      },
      toggleIconStatus(status) {
        if (!status) {
          this.starList[this.num].status = !status;
        } else {
          this.starList[this.num - 1].status = !status;
        }
        if (status) {
          this.num = this.num - 1;
        } else {
          this.num = this.num + 1;
        }
        this.$emit('starNum', this.num);
      },
    },
    created() {
      this.fetchStarList(this.starNum);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .star-list {
    display: flex;
  }

  .icon-rate {
    font-size: @font-size-large;
    margin-right: @size-extra-small;
    color: @color-text-lighter;
    &.is-active {
      color: @color-highlight;
    }
  }

</style>
